const AngularLogo = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 128 128"
      fill="none"
      className="skill-icon"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M52.8637 64.0004H76.1437L63.7687 38.1234L52.8637 64.0004ZM63.8097 1.02637L4.55273 21.8804L13.9157 99.5174L63.8727 126.974L114.087 99.1464L123.447 21.5114L63.8097 1.02637ZM48.0437 75.0004L40.7787 93.1764L27.1977 93.2324L63.8057 12.1534L63.7357 12.0004H63.6717L63.6727 11.8674L63.7357 12.0004H63.8767L63.9997 11.7264V12.0004H63.8767L63.8067 12.1534L101.996 93.5704L88.9217 93.2834L80.8797 74.7034L63.7067 74.7854"
        fill="#00E96C"
      />
    </svg>
  );
};

export default AngularLogo;
